import React, { useState } from 'react';

import { parse, stringify } from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDebounce } from 'react-use';

import { FilterCurrency, type FilterCurrencyProps } from '@pkg/components/Sections/Profile/Filters';
import { type InputFloorPriceRangeOnChange } from '@pkg/components/Sections/Profile/Inputs';
import { GROUPS_HOME_SEARCH_PARAMS_KEYS } from '@pkg/hooks';
import { useSearchParams } from '@pkg/hooks/ReactRouter';

export type GroupFiltersFloorPriceProps = Pick<FilterCurrencyProps, 'index'>;

// TODO: Right now, this is ONLY used for `Groups` filtering,
// and not `Group`. Eventually, once we are ready to support both,
// this needs to be converted to use `useNftFilter()`.
export function GroupFiltersFloorPrice({ index }: GroupFiltersFloorPriceProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const maxFloorPrice = searchParams.get(GROUPS_HOME_SEARCH_PARAMS_KEYS.max_floor_price);
    const minFloorPrice = searchParams.get(GROUPS_HOME_SEARCH_PARAMS_KEYS.min_floor_price);

    const parsedMaxFloorPrice = maxFloorPrice ? parseFloat(maxFloorPrice) : undefined;
    const parsedMinFloorPrice = minFloorPrice ? parseFloat(minFloorPrice) : undefined;

    const [floorPriceLe, setFloorPriceLe] = useState<number | undefined>(parsedMaxFloorPrice);
    const [floorPriceGe, setFloorPriceGe] = useState<number | undefined>(parsedMinFloorPrice);

    const updateFilters = (filters?: InputFloorPriceRangeOnChange) => {
        if (filters) {
            const { floorPriceLe, floorPriceGe } = filters;
            setFloorPriceLe(floorPriceLe);
            setFloorPriceGe(floorPriceGe);
        }
    };

    useDebounce(
        () => {
            const query = parse(location.search);

            if (floorPriceLe) {
                query['max_floor_price'] = floorPriceLe?.toString();
            } else {
                delete query['max_floor_price'];
            }

            if (floorPriceGe) {
                query['min_floor_price'] = floorPriceGe?.toString();
            } else {
                delete query['min_floor_price'];
            }

            const route = stringify(query);
            navigate(`${location.pathname}?${route}`);
        },
        500,
        [floorPriceGe, floorPriceLe],
    );

    return (
        <FilterCurrency isWide index={index} onChange={updateFilters} initialState={{ floorPriceGe, floorPriceLe }} />
    );
}
